import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Materiais',
  path: '/merenda/mermaterial',
  name: 'mermaterial',
  component: () => import('@/views/merenda/mermaterial/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.MATERIAISNOVO_MENU_1900100199],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Materiais',
  path: '/merenda/mermaterial/cadastro/:id?',
  parent: 'mermaterial',
  name: 'mermaterial_create',
  component: () => import('@/views/merenda/mermaterial/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.MATERIAISNOVO_MENU_1900100199],
  },
  goesToMenu: true,
 },
 {
  description: 'Materiais Alimentação',
  path: '/merenda/mermaterialalimentacao',
  name: 'mermaterialalimentacao',
  component: () => import('@/views/merenda/mermaterial/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.ALIMENTOSNOVO_MENU_1000100199],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Materiais Alimentação',
  path: '/merenda/mermaterialalimentacao/cadastro/:id?',
  parent: 'mermaterialalimentacao',
  name: 'mermaterialalimentacao_create',
  component: () => import('@/views/merenda/mermaterial/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.ALIMENTOSNOVO_MENU_1000100199],
  },
  goesToMenu: true,
 },
]
